import {
    GET_ASSETS,
    ADD_ASSET,
    EDIT_ASSET,
    DELETE_ASSET,
    SET_USERS,
    SET_LOADING,
    SET_ERROR,
    ASSETS_DATA
} from '../actions/assetActions';

const initialState = {
    assets: [],
    users: [],
    loading: false,
    error: null,
    assets_stat_data: [],
};

export default function assetReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ASSETS:
            return {
                ...state,
                assets: action.payload,
                loading: false,
                error: null
            };
        case ADD_ASSET:
            return {
                ...state,
                assets: [...state.assets, action.payload],
                loading: false,
                error: null
            };
        case EDIT_ASSET:
            return {
                ...state,
                assets: state.assets.map(asset =>
                    asset.id === action.payload.id ? action.payload : asset
                ),
                loading: false,
                error: null
            };
        case DELETE_ASSET:
            return {
                ...state,
                assets: state.assets.filter(asset => asset.id !== action.payload),
                loading: false,
                error: null
            };
        case SET_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };
        case SET_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case SET_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                error: null
            };

        case ASSETS_DATA:
            return {
                ...state,
                assets_stat_data: action.payload,
            };
        default:
            return state;
    }
}